import React from "react";

const norm = (s) => (s || "").trim().toLocaleUpperCase("tr-TR");
const TONE = {
  "İNFAZ": "text-emerald-700 bg-emerald-50 border-emerald-200",
  "KISMİ ÖDEME": "text-amber-700 bg-amber-50 border-amber-200",
};

export function DosyaDurumuBadge({ v, id, tarih }) {
  const k = norm(v);
  if (!k) return null;
  const d = tarih ? tarih.slice(8, 10) + "." + tarih.slice(5, 7) + "." + tarih.slice(0, 4) : "";
  return (
    <span data-testid={`tahsilat-dosya-durumu-${id}`} title={d ? `${k} olarak işaretlendi: ${d}` : k}
      className={`ml-1.5 align-middle inline-block px-1.5 py-px rounded border text-[9px] font-bold tracking-wide whitespace-nowrap ${TONE[k] || "text-slate-600 bg-slate-50 border-slate-200"}`}>
      {k === "İNFAZ" ? "infaz" : k.toLocaleLowerCase("tr-TR")}
      {d && <span className="font-medium opacity-80" data-testid={`tahsilat-dosya-durumu-tarih-${id}`}> · {d.slice(0, 5)}</span>}
    </span>
  );
}

const OPTS = [["", "Tümü"], ["İNFAZ", "İnfaz"], ["KISMİ ÖDEME", "Kısmi Ödeme"]];

export function DosyaDurumuFilter({ value, onChange }) {
  return (
    <div className="inline-flex items-center gap-1 text-xs" data-testid="tahsilat-dosya-durumu-filter">
      <span className="text-slate-500 font-semibold">D. Durumu:</span>
      {OPTS.map(([v, l]) => {
        const on = norm(value) === v;
        const tone = v === "İNFAZ" ? "bg-emerald-600 border-emerald-600" : v ? "bg-amber-500 border-amber-500" : "bg-slate-800 border-slate-800";
        return (
          <button key={v || "all"} type="button" onClick={() => onChange(v)} data-testid={`tahsilat-dd-filter-${v ? (v === "İNFAZ" ? "infaz" : "kismi") : "all"}`}
            className={`px-2 py-1 rounded-md border font-semibold transition-colors ${on ? `${tone} text-white` : "bg-white border-slate-300 text-slate-700 hover:bg-slate-50"}`}>
            {l}
          </button>
        );
      })}
    </div>
  );
}
